import { cn } from '@/lib/utils'

type HighlightProps = {
  icon: React.ReactNode
  primary: string
  secondary: string
  onClick?: () => void
  // Optional className applied to the `secondary` text only. Callers use this
  // to apply `meticulous-ignore` when the secondary value is a live aggregate
  // (e.g. `X claims`) that drifts between Meticulous runs.
  secondaryClassName?: string
}

export default function Highlight({
  icon,
  primary,
  secondary,
  onClick,
  secondaryClassName,
}: HighlightProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'hidden w-fit items-center gap-2 truncate rounded-full border border-white/15 bg-black/50 p-1 pr-3.5 text-white backdrop-blur-sm md:flex',
        onClick && 'cursor-pointer',
      )}
    >
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500">
        {icon}
      </div>
      <p className="shrink-0">{primary}</p>
      <p className={cn('shrink-0 text-white/60', secondaryClassName)}>{secondary}</p>
    </div>
  )
}
